import { CreditCardPaymentMethod } from "../types";

export const computeCreditCardStatus = (
  cards: [CreditCardPaymentMethod] | CreditCardPaymentMethod[] | null | undefined,
): "valid" | "expired" | "expiringSoon" => {
  const firstCard = Array.isArray(cards) ? cards[0] : undefined;
  // return "expired";

  if (!firstCard) {
    return "valid";
  }

  const { expiryMonth, expiryYear } = firstCard;
  const expiryDate = new Date(expiryYear, expiryMonth, 0, 23, 59, 59);
  if (Number.isNaN(expiryDate.getTime())) {
    return "valid";
  }

  const now = new Date();
  if (expiryDate.getTime() < now.getTime()) {
    return "expired";
  }

  const threshold = new Date(now);
  threshold.setDate(threshold.getDate() + 30);
  if (expiryDate.getTime() <= threshold.getTime()) {
    return "expiringSoon";
  }

  return "valid";
};
